const truncate = (text: string, maxCharacters = 25): string =>
  text && text.length > maxCharacters
    ? `${text.substring(0, maxCharacters)}…`
    : text

export default truncate
